var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreateNewD = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#create-new-d_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242427",
  d: "M40 79.535c21.832 0 39.53-17.697 39.53-39.529C79.53 18.174 61.831.476 40 .476 18.17.477.47 18.175.47 40.007c0 21.831 17.699 39.53 39.53 39.53Z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#create-new-d_svg__b)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "create-new-d_svg__c",
  width: 62,
  height: 62,
  x: 9,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M70.086 9.915H9.915v60.171h60.171V9.915Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#create-new-d_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#create-new-d_svg__d)",
  strokeWidth: 1.724,
  d: "M26.616 41.595c-.464 1.325-.6 2.744-.6 4.135 0 8.062 6.536 14.598 14.599 14.598h7.044c.752 0 1.489-.06 2.207-.17l3.9 1.938c1.646.817 3.54-.524 3.316-2.348l-.32-2.606a14.571 14.571 0 0 0 5.495-11.412c0-7.927-6.318-14.378-14.193-14.593h-.043l-7.416.168c-6.658.004-11.983 4.56-13.989 10.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__e)",
  d: "M40.615 32.167c-6.244 0-11.281 4.275-13.185 9.713-.42 1.197-.551 2.508-.551 3.85 0 7.587 6.15 13.736 13.736 13.736h7.045c.799 0 1.58-.072 2.342-.203l4.148 2.06c1.03.513 2.218-.327 2.077-1.47l-.38-3.093a13.715 13.715 0 0 0 5.549-11.03c0-7.459-5.945-13.529-13.355-13.731l-7.426.168Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__f)",
  d: "M29.574 17.306h6.32c6.805 0 12.322 5.517 12.322 12.322 0 .787-.074 1.557-.215 2.303-1.079 5.705-6.09 9.933-12.107 9.933h-6.32c-.716 0-1.418.022-2.1-.096l-3.722 1.849a1.297 1.297 0 0 1-1.864-1.32l.341-2.775a12.304 12.304 0 0 1-4.977-9.894c0-6.805 5.517-12.322 12.322-12.322Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__g)",
  d: "M17.928 33.772a12.354 12.354 0 0 0 4.274 5.785l-.34 2.775a1.297 1.297 0 0 0 1.863 1.32l3.721-1.849c.683.118 1.384.096 2.101.096h6.32c5.364 0 9.84-3.342 11.533-8.127H17.928Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#create-new-d_svg__h)",
  strokeWidth: 1.724,
  d: "m23.37 42.845 3.72-1.848.253-.125.277.047c.51.088 1.03.086 1.651.084h6.623c5.605 0 10.26-3.935 11.26-9.232.132-.693.2-1.41.2-2.143 0-6.329-5.13-11.46-11.46-11.46h-6.32c-6.329 0-11.46 5.131-11.46 11.46 0 3.77 1.82 7.113 4.63 9.203l.402.3-.06.497-.342 2.775a.435.435 0 0 0 .625.442Zm0 0 .363.732"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__i)",
  d: "M39.409 31.681a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__j)",
  d: "M32.664 31.681a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__k)",
  d: "M25.993 31.681a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__l)",
  d: "M50.821 48.807a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__m)",
  d: "M44.065 48.807a2.408 2.408 0 1 0 0-4.815 2.408 2.408 0 0 0 0 4.815Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-new-d_svg__n)",
  d: "M37.38 48.803a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816Z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__d",
  x1: 33.008,
  x2: 47.724,
  y1: 35.353,
  y2: 60.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__e",
  x1: 54.102,
  x2: 44.976,
  y1: 61.389,
  y2: 34.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#4ECFB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#1384C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__f",
  x1: 23.634,
  x2: 33.534,
  y1: 17.306,
  y2: 41.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__g",
  x1: 32.664,
  x2: 32.664,
  y1: 34.867,
  y2: 41.96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4071F7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30569F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__h",
  x1: 22.751,
  x2: 35.956,
  y1: 20.316,
  y2: 42.601,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__i",
  x1: 40.74,
  x2: 37.322,
  y1: 27.942,
  y2: 31.361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__j",
  x1: 33.995,
  x2: 30.576,
  y1: 27.942,
  y2: 31.361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__k",
  x1: 27.324,
  x2: 23.906,
  y1: 27.942,
  y2: 31.361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__l",
  x1: 52.152,
  x2: 48.734,
  y1: 45.068,
  y2: 48.487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__m",
  x1: 45.396,
  x2: 41.978,
  y1: 45.068,
  y2: 48.487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-new-d_svg__n",
  x1: 38.712,
  x2: 35.293,
  y1: 45.065,
  y2: 48.483,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "create-new-d_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "create-new-d_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.5 13.91h55v52.18h-55z"
})))));
export { SvgCreateNewD as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOTUxNjhlZWMyNzJmZGZiZmZhNGNjMzE5MzNiODc1ZTEuc3ZnIjs=";